import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { IHeaderCustomizations } from 'interface/customizations';
import * as service from 'services/customization';

interface IState extends IHeaderCustomizations {
  portal?: IHeaderCustomizations;
}

const initialState: IState = {
  header_logo: null,
  header_background_color: null,
  header_link_color: null,
  support_external_url: null,
  portal: null,
};

export const getPortalCustomization = createAsyncThunk('portal/fetch', () => service.getPortalCustomization());

export const customizationsSlice = createSlice({
  name: 'customizations',
  initialState,
  reducers: {
    setCustomization: (state, action: PayloadAction<IHeaderCustomizations>) => {
      state.header_logo = action.payload?.header_logo;
      state.header_background_color = action.payload?.header_background_color;
      state.header_link_color = action.payload?.header_link_color;
      state.support_external_url = action.payload?.support_external_url;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getPortalCustomization.fulfilled, (state, action: PayloadAction<IHeaderCustomizations>) => {
      state.portal = {
        header_background_color: action.payload?.header_background_color,
        header_link_color: action.payload?.header_link_color,
        support_external_url: action.payload?.support_external_url,
        header_logo: action.payload?.header_logo,
      };
    });
  },
});

export const { setCustomization } = customizationsSlice.actions;
export default customizationsSlice.reducer;
